export const GET_PENDING_CHANGES = "GET_PENDING_CHANGES"
export const APPROVE_PENDING_CHANGE = "APPROVE_PENDING_CHANGE"
export const REJECT_PENDING_CHANGE = "REJECT_PENDING_CHANGE"
export const CLEAR_CHANGES_MESSAGE = "CLEAR_CHANGES_MESSAGE"
export const GET_ENTITY_PENDING_CHANGE = "GET_ENTITY_PENDING_CHANGE"
export const CLEAR_ENTITY_PENDING_CHANGE = "CLEAR_ENTITY_PENDING_CHANGE"
